var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import QueueFromPayload from 'components/powerFlowShared/components/queueFromPayload';
import { FlowNodeTypes, } from 'components/powerFlowShared/components/types';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { VoicemailModal as ActionModal } from '../modals/voicemail';
export class VoicemailNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        return (_jsx(FlowNode, { color: VoicemailNode.color, icon: VoicemailNode.icon, label: VoicemailNode.label, text: _jsxs("div", { children: [_jsx(AnnounceFromPayload, { node: this.props.node, extraData: this.props.extraData }), _jsx(QueueFromPayload, { node: this.props.node })] }), onEdit: this.triggerEdit }));
    }
}
VoicemailNode.icon = 'conversations';
VoicemailNode.label = 'Voicemail';
VoicemailNode.helpText = 'Record or upload a voicemail asking your customers to leave a message if no agents are available.';
VoicemailNode.color = flowNodeColor.green;
VoicemailNode.ActionModal = ActionModal;
VoicemailNode.actionTrigger = { type: FlowNodeTypes.VOICEMAIL };
VoicemailNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    if (payload === null || payload === void 0 ? void 0 : payload.queue) {
        payload.queue.value = newConnection;
    }
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], VoicemailNode.prototype, "triggerEdit", null);
